import { Config } from '@/types/config';

export default ({ index, appConfig }: { index: number; appConfig: Config }) => !appConfig.chatHideOpenButton ? `
    <div class="odr-chat-opener ${appConfig.chatPositionLeft ? 'odr-chat-opener_position-left' : ''}" data-odr-widget="${index}" data-odr-wrap="${index}">
        <div class="odr-chat-opener__button ${appConfig.chatButtonImage ? 'odr-chat-opener__button_image' : ''}" data-odr-opener="${index}">
            <div class="odr-chat-opener__icon">
                ${!appConfig.chatButtonImage ? `
                <svg class="odr-svg" xmlns="http://www.w3.org/2000/svg" style="vertical-align: middle" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path fill="#ffffff" d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/>
                </svg>` : `
                <img class="odr-chat-opener__image" style="background-image: url(${appConfig.chatButtonImage}) !important;"/>`}
            </div>
            ${appConfig.chatButtonHeader ? `
            <div class="odr-chat-opener__title" data-odr-opener-title="${index}">
                ${appConfig.chatButtonHeader}
            </div>` : ''}
        </div>
    </div>
    <span data-odr-container="${index}"></span>
` : `<span data-odr-container="${index}"></span>`;
